import { lazy } from 'react'
import { ROUTE_PATHS } from 'utils/constants/index'

// crash-games
const AztecManGame = lazy(() => import('games/crash-games/AztecManGame/index'))
const GalaxyGrabGame = lazy(() => import('games/crash-games/GalaxyGrabGame/index'))
const FollowTheArrowGame = lazy(() => import('games/crash-games/FollowTheArrowGame/index'))
const PowerOfThorGame = lazy(() => import('games/crash-games/PowerOfThorGame/index'))
const HappyBirdGame = lazy(() => import('games/crash-games/HappyBirdGame/index'))

// fast-games
const BlackjackGame = lazy(() => import('games/fast-games/BlackjackGame/index'))
const MineGame = lazy(() => import('games/fast-games/MineGame/index'))
const PlinkoGame = lazy(() => import('games/fast-games/PlinkoGame/index'))
const RouletteGame = lazy(() => import('games/fast-games/RouletteGame'))

// slots-games
const SlotGames = lazy(() => import('games/slot-games/index'))

export const crashRoutesList = [
  {
    path: ROUTE_PATHS.aztecManGame,
    component: AztecManGame,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.galaxyGrabGame,
    component: GalaxyGrabGame,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.followTheArrowGame,
    component: FollowTheArrowGame,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.powerOfThorGame,
    component: PowerOfThorGame,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.happyBirdGame,
    component: HappyBirdGame,
    isPrivate: false
  }
]

export const slotsRoutesList = [
  {
    path: ROUTE_PATHS.PandaPunchSlotGame,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.witchcauldronSlotGame,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.vikingSwordSlotGame,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.roadOfAnubisSlotGame,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.wildMafiaSlotGame,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.mayaBonanza,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.cosmicHeroes,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.egyptRush,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.dragonCurse,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.cyberBox,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.powerShield,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.gatesOfTitan,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.guardianOfHeaven,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.pineappleParadise,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.purpleCave,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.spaceWars,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.ghostGuest,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.destroyMonster,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.aztecProtector,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.lopenSecret,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.punchOfHeroes,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.diamondGun,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.jellyBoom,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.zodiacRush,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.sweetRush,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.moneyRate,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.upgrade2199,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.theNorthFisher,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.theMiner,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.luckyFarmer,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.theHunter,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.dizzyZombies,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.catHouse,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.egyptRising,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.fiestaParty,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.kingdomFire,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.ninjaParadise,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.wantedDeadOrNinja,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.wantedCowboy,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.gatesOfNinja,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.dede1000x,
    component: SlotGames,
    isPrivate: false
  },
  
  {
    path: ROUTE_PATHS.shiningRingRising,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.olympusRising,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.ottomanLegends,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.warGods,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.dragonsVsGuardian,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.streetBattle,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.lostAtlantis,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.lastSamurai,
    component: SlotGames,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.zeroth,
    component: SlotGames,
    isPrivate: false
  }
]

export const fastGameRoutesList = [
  {
    path: ROUTE_PATHS.blackjackGame,
    component: BlackjackGame,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.mineGame,
    component: MineGame,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.plinkoGame,
    component: PlinkoGame,
    isPrivate: false
  },
  {
    path: ROUTE_PATHS.rouletteGame,
    component: RouletteGame,
    isPrivate: false
  }
]
